import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../Vp/viewpro.css";
import "./adminvp.css";
import axios from "axios";
import { API_BASE_URL } from "../api_config";
import { FaUser, FaEnvelope, FaPhone, FaGraduationCap, FaBriefcase, FaMapMarkerAlt, FaHeart, FaLanguage, FaRupeeSign, FaRulerVertical, FaWeight, FaHome, FaTree, FaUtensils } from "react-icons/fa";
import { MdFamilyRestroom, MdOutlineTempleHindu } from "react-icons/md";

function ViewProfile() {
  const [getProf, setGetProf] = useState({});
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const profId = location.state.userId;

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/api/get-prof/${profId}`, { withCredentials: true })
      .then((res) => {
        setGetProf({ ...res.data[0] });
        setLoading(false);
      })
      .catch((err) => {
        alert("Something error occured");
        setLoading(false);
      });
  }, [profId]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const toggleImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (isModalOpen) {
        const modalContent = document.querySelector(".preview-modal-content");
        if (modalContent && !modalContent.contains(event.target)) {
          setIsModalOpen(false);
        }
      }
    };

    window.addEventListener("click", handleOutsideClick, true);

    return () => {
      window.removeEventListener("click", handleOutsideClick, true);
    };
  }, [isModalOpen]);

  function formatDOB(dob) {
    if (!dob) return "N/A";
    const dobDate = new Date(dob);
    const year = dobDate.getFullYear();
    const month = String(dobDate.getMonth() + 1).padStart(2, "0");
    const day = String(dobDate.getDate()).padStart(2, "0");
    const formattedDOB = `${year}-${month}-${day}`;
    return formattedDOB;
  }

  function numFor(number) {
    if (!number) return "N/A";
    const numFormat = Intl.NumberFormat("en-IN");
    const newFor = numFormat.format(number);
    return newFor;
  }

  if (loading) {
    return (
      <div className="admin-loading-container">
        <div className="admin-loading-spinner"></div>
        <p>Loading profile data...</p>
      </div>
    );
  }

  return (
    <section className="admin-profile-section">
      <div className="admin-profile-header">
        <div className="admin-profile-image-container">
          <img
            src={`${API_BASE_URL}/uploads/` + getProf.filename}
            alt={`${getProf.first_name}`}
            className="admin-profile-image"
            onClick={() =>
              toggleImageModal(`${API_BASE_URL}/uploads/` + getProf.filename)
            }
          />
          <div className="image-overlay">
            <span>Click to view</span>
          </div>
        </div>
        <div className="admin-profile-info">
          <h1 className="admin-profile-name">
            {getProf.first_name} {getProf.last_name}
          </h1>
          <div className="admin-profile-highlight">
            <div className="admin-highlight-item">
              <FaUser className="admin-highlight-icon" />
              <span className="admin-highlight-text">{getProf.age} years</span>
            </div>
            <div className="admin-highlight-item">
              <FaHeart className="admin-highlight-icon" />
              <span className="admin-highlight-text">{getProf.marital_status}</span>
            </div>
            <div className="admin-highlight-item">
              <FaLanguage className="admin-highlight-icon" />
              <span className="admin-highlight-text">{getProf.mother_tongue}</span>
            </div>
            <div className="admin-highlight-item">
              <FaRupeeSign className="admin-highlight-icon" />
              <span className="admin-highlight-text">{numFor(getProf.income)}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="admin-profile-content">
        <div className="admin-profile-section">
          <h2 className="admin-section-title">Personal Information</h2>
          <div className="admin-info-grid">
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaUser className="admin-info-icon" />
                <span>Date of Birth</span>
              </div>
              <div className="admin-info-value">{formatDOB(getProf.dob)}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaEnvelope className="admin-info-icon" />
                <span>Email</span>
              </div>
              <div className="admin-info-value">{getProf.email || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaPhone className="admin-info-icon" />
                <span>Mobile Number</span>
              </div>
              <div className="admin-info-value">{getProf.mobile_number || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaGraduationCap className="admin-info-icon" />
                <span>Education</span>
              </div>
              <div className="admin-info-value">{getProf.education || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaBriefcase className="admin-info-icon" />
                <span>Occupation</span>
              </div>
              <div className="admin-info-value">{getProf.occupation || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaBriefcase className="admin-info-icon" />
                <span>Company</span>
              </div>
              <div className="admin-info-value">{getProf.company_name || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaBriefcase className="admin-info-icon" />
                <span>Employment Type</span>
              </div>
              <div className="admin-info-value">{getProf.employment_type || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaRulerVertical className="admin-info-icon" />
                <span>Height</span>
              </div>
              <div className="admin-info-value">{getProf.height ? `${getProf.height} cm` : "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaWeight className="admin-info-icon" />
                <span>Weight</span>
              </div>
              <div className="admin-info-value">{getProf.weight ? `${getProf.weight} kg` : "N/A"}</div>
            </div>
          </div>
        </div>

        <div className="admin-profile-section">
          <h2 className="admin-section-title">Address Information</h2>
          <div className="admin-info-item admin-address-item">
            <div className="admin-info-label">
              <FaMapMarkerAlt className="admin-info-icon" />
              <span>Address</span>
            </div>
            <div className="admin-info-value">
              {getProf.address ? (
                <>
                  {getProf.address}, {getProf.address1 || ""}<br />
                  {getProf.city_name}, {getProf.state_name}, {getProf.country_name}
                </>
              ) : (
                "N/A"
              )}
            </div>
          </div>
        </div>

        <div className="admin-profile-section">
          <h2 className="admin-section-title">Family Information</h2>
          <div className="admin-info-grid">
            <div className="admin-info-item">
              <div className="admin-info-label">
                <MdFamilyRestroom className="admin-info-icon" />
                <span>Father's Name</span>
              </div>
              <div className="admin-info-value">{getProf.father_name || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <MdFamilyRestroom className="admin-info-icon" />
                <span>Mother's Name</span>
              </div>
              <div className="admin-info-value">{getProf.mother_name || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <MdFamilyRestroom className="admin-info-icon" />
                <span>Family Status</span>
              </div>
              <div className="admin-info-value">{getProf.family_status || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <MdFamilyRestroom className="admin-info-icon" />
                <span>Family Type</span>
              </div>
              <div className="admin-info-value">{getProf.family_type || "N/A"}</div>
            </div>
          </div>
        </div>

        <div className="admin-profile-section">
          <h2 className="admin-section-title">Religious Information</h2>
          <div className="admin-info-grid">
            <div className="admin-info-item">
              <div className="admin-info-label">
                <MdOutlineTempleHindu className="admin-info-icon" />
                <span>Religion</span>
              </div>
              <div className="admin-info-value">{getProf.religion || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <MdOutlineTempleHindu className="admin-info-icon" />
                <span>Caste</span>
              </div>
              <div className="admin-info-value">{getProf.caste || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <MdOutlineTempleHindu className="admin-info-icon" />
                <span>Kulam</span>
              </div>
              <div className="admin-info-value">{getProf.kulam || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <MdOutlineTempleHindu className="admin-info-icon" />
                <span>Star</span>
              </div>
              <div className="admin-info-value">{getProf.star || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <MdOutlineTempleHindu className="admin-info-icon" />
                <span>Raasi</span>
              </div>
              <div className="admin-info-value">{getProf.raasi || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <MdOutlineTempleHindu className="admin-info-icon" />
                <span>Chevvai Dosham</span>
              </div>
              <div className="admin-info-value">{getProf.chevvai_dosham === "chevvai" ? "Yes" : "No"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <MdOutlineTempleHindu className="admin-info-icon" />
                <span>Naga Dosham</span>
              </div>
              <div className="admin-info-value">{getProf.naga_dosham === "naga" ? "Yes" : "No"}</div>
            </div>
          </div>
        </div>

        <div className="admin-profile-section">
          <h2 className="admin-section-title">Other Details</h2>
          <div className="admin-info-grid">
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaHome className="admin-info-icon" />
                <span>Home Details</span>
              </div>
              <div className="admin-info-value">{getProf.home_details || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaTree className="admin-info-icon" />
                <span>Agricultural Land</span>
              </div>
              <div className="admin-info-value">{getProf.agri_land || "N/A"}</div>
            </div>
            <div className="admin-info-item">
              <div className="admin-info-label">
                <FaUtensils className="admin-info-icon" />
                <span>Food Habits</span>
              </div>
              <div className="admin-info-value">{getProf.food_habits || "N/A"}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="admin-profile-section admin-horoscope-section">
        <h2 className="admin-section-title">Horoscope Information</h2>
        <div className="horoscope-charts-container">
          {/* Rasi Chart */}
          <div className="chart-container">
            <div className="chart-grid">
              <div className="chart-cell">
                <span className="planet">{getProf.box1 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box2 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box3 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box4 || ""}</span>
              </div>

              <div className="chart-cell">
                <span className="planet">{getProf.box5 || ""}</span>
              </div>
              <div className="chart-cell center-cell">
                <div className="chart-title">ராசி</div>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box6 || ""}</span>
              </div>

              <div className="chart-cell">
                <span className="planet">{getProf.box7 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box8 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box9 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box10 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box11 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box12 || ""}</span>
              </div>
            </div>
          </div>

          {/* Navamsa Chart */}
          <div className="chart-container">
            <div className="chart-grid">
              <div className="chart-cell">
                <span className="planet">{getProf.box13 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box14 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box15 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box16 || ""}</span>
              </div>

              <div className="chart-cell">
                <span className="planet">{getProf.box17 || ""}</span>
              </div>
              <div className="chart-cell center-cell">
                <div className="chart-title">நவம்சம்</div>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box18 || ""}</span>
              </div>

              <div className="chart-cell">
                <span className="planet">{getProf.box19 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box20 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box21 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box22 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box23 || ""}</span>
              </div>
              <div className="chart-cell">
                <span className="planet">{getProf.box24 || ""}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="admin-preview-image-modal">
          <div className="admin-preview-modal-content">
            <span className="admin-preview-close" onClick={() => setIsModalOpen(false)}>
              &times;
            </span>
            <img
              src={selectedImage}
              alt="Full Size"
              className="admin-preview-image"
            />
          </div>
        </div>
      )}
    </section>
  );
}

export default ViewProfile;
